import React from 'react'
import { Alert } from 'react-bootstrap'

const Message = ( { variant , children}) => {
  const classes = ['app-empty-state', 'mb-0'];
  if (variant === 'danger') {
    classes.push('app-empty-state--danger');
  }

  return (
    <Alert className={classes.join(' ')}>
      {children}
    </Alert>
  )
}

// Default props in case no variant is provided
Message.defaultProps = {
  variant: 'info',
}


export default Message
